/* eslint-disable @typescript-eslint/no-explicit-any */

export enum OptionType {
    extra = 1,
    header,
    menu,
    collapse,
    panel,
    stage,
    cols1,
    cols2,
    cols3,
    photoEditorStage,
}

const layoutNodes: React.ReactNode[] = [];
export function getLayoutNode(children: any[]) {
    layoutNodes.length = 0;
    for (let i = 0; i < (children as any[]).length; i++) {
        const item = (children as any[])[i];
        if (item) {
            layoutNodes.push(item);
        }
    }
    return layoutNodes;
}

export function getRenderNode(type: OptionType) {
    return layoutNodes.filter((item) => {
        return (item as any)?.props.type === type;
    });
}
